import { Component, OnInit, Input   } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharingService } from '../../../modules/shared/shared.service';


@Component({
  selector: 'app-custom-spinner',
  templateUrl: './custom-spinner.component.html',
  styleUrls: ['./custom-spinner.component.css']
})
export class CustomSpinnerComponent implements OnInit {
  selectedLang: any;
  delayText: any;
  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.delayMessage();
  }
  
  get data(){
    this.selectedLang = this.translate.defaultLang;
    return this.selectedLang;
  }

  delayMessage(){
    if(this.selectedLang == "FR"){
      var y = sessionStorage.getItem("presentLang");
      this.delayText = y;
    } else {
      var x = sessionStorage.getItem("presentLang");
      this.delayText = x;
    }
  }
}
